// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { secondaryNavigationStyles } from "@rpsc/Overrides/Widgets/Header/SecondaryNavigation";
import { DivWrapper } from "@rpsc/XDL/constants";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

secondaryNavigationStyles.container = {
    css: css`
        background-color: ${color("primary")};
        color: ${color("common.white")};
        width: 100%;
        padding: 8px 0;
        ${xScreen("lte", "lg")} {
            padding: 4px 0;
        }
        overflow: hidden;
    `,
};

secondaryNavigationStyles.warehousePickupLink = {
    css: css`
        display: flex;
        flex: 1;
        & > ${DivWrapper} {
            display: flex;
        }
    `,
};

secondaryNavigationStyles.wrapper = {
    css: css`
        ${layoutContainer}
        background-color: transparent;
        justify-content: space-between;
        text-transform: unset;
        height: unset;
        ${TypographyStyle} {
            font-size: 14px;
            line-height: 17px;
            font-weight: ${fontConfig.weight.bold};
            color: ${color("common.white")} !important;
        }
        .phone-link {
            & > ${DivWrapper} > div {
                padding: 0;
                max-width: unset;
            }
            a:hover ${TypographyStyle} {
                color: ${color("common.ui8")} !important;
                opacity: 1;
            }
        }
    `,
};

secondaryNavigationStyles.centerSide = {
    css: css`
        display: flex;
        flex: 2;
        align-items: center;
        justify-content: center;
        ${TypographyStyle} ,${StyledButton} > ${TypographyStyle} {
            margin: 0;
            text-align: center;
            font-size: 14px;
            line-height: 17px;
            &:hover {
                opacity: 0.66;
            }
            ${xScreen("lte", "lg")} {
                font-size: 20px;
                line-height: 28px;
            }
        }
    `,
};

secondaryNavigationStyles.rightSide = {
    css: css`
        display: flex;
        align-items: center;
        gap: 16px;
        justify-content: end;
        flex: 1;
        & > span:has(> ${DivWrapper}:empty) {
            display: none;
        }
    `,
};
